import { Customer, GcpPlacementService, Site } from '../../../../../../types';
import { useUploadStore } from '../../../../../../store/uploadStore';
import { CalculatedUploadState } from '../../../tabs/card/useCalculatedUploadState';
import { determineIsGcpPlacementMissionCompleted } from '../../../helpers/completion';

/**
 * Determines status in the mission scope Badge
 */
export const useCalculatedGcpRequestState = (
  customer: Customer,
  site: Site,
  gcpPlacementService?: GcpPlacementService,
) => {
  const { getGcpRequest, hasGcpFormChanges } = useUploadStore();

  const gcpRequest = getGcpRequest(customer.id, site.id);

  if (!gcpRequest) {
    if (gcpPlacementService) {
      return determineIsGcpPlacementMissionCompleted(gcpPlacementService) ? CalculatedUploadState.Completed : null;
    }

    return null;
  }

  if (hasGcpFormChanges(customer.id, site.id)) {
    return CalculatedUploadState.Loading;
  }

  if (gcpRequest.measurements.length) {
    return CalculatedUploadState.Completed;
  }

  return gcpRequest.measurements.length ? CalculatedUploadState.Completed : null;
};
